export function slugify(text) {
    if (!text) return '';
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')        // Replace spaces with -
        .replace(/[^\p{L}\p{N}\-]+/gu, '') // Remove all non-word chars
        //.replace(/[^\w\-]+/g, '')    // Remove all non-word chars
        .replace(/\-\-+/g, '-');     // Replace multiple - with single -
}

export function deslugify(slug) {
    if (!slug) return '';
    return slug
        .toString()
        .toLowerCase()
        .replace(/-/g, ' ')             // Replace hyphens with spaces
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word (optional)
}

export function getDecodedPathParam(urlOrPath, pattern, paramName) {

    const dummyBase = 'http://dummy.local';
    const urlObj = urlOrPath.startsWith('http')
        ? new URL(urlOrPath)
        : new URL(urlOrPath, dummyBase);

    const pathSegments = urlObj.pathname.split('/').filter(Boolean);
    const patternSegments = pattern.split('/').filter(Boolean);

    const startIndex = pathSegments.indexOf(patternSegments[0]);
    if (startIndex === -1) return null;

    const params = {};

    patternSegments.forEach((segment, index) => {
        if (segment.startsWith(':')) {
            const key = segment.slice(1);
            const value = pathSegments[startIndex + index];
            if (value !== undefined) {
                params[key] = decodeURIComponent(value);
            }
        }
    });

    return params[paramName] || null;
}

export function detectScript(text) {
    if (/[ء-ي]/.test(text)) {
        return 'arabic';
    } else if (/[a-zA-Z]/.test(text)) {
        return 'english';
    }
    return 'unknown';
}


export function replacePathParams(url, pattern, replacements) {

    const urlObj = new URL(url);

    const pathSegments = urlObj.pathname.split('/').filter(Boolean);
    const patternSegments = pattern.split('/').filter(Boolean);

    const newSegments = patternSegments.map((segment, index) => {
        if (segment.startsWith(':')) {
            const key = segment.slice(1);
            const value = replacements[key] || pathSegments[index];
            if (key === 'idProject' || key === 'idDeveloper' || key === 'idProperty') return value;
            return encodeURIComponent(value);
            // return encodeURIComponent(replacements[key] || pathSegments[index]);
        }
        return segment;
    });

    const newPath = '/' + newSegments.join('/');
    const newUrl = urlObj.origin + newPath + urlObj.search;
    return newUrl;
}


const SALT = '12846';

export function encodeId(id) {

    if (!id) return '';
    return btoa((parseInt(id) + 256).toString())

}

export function decodeId(encoded) {
    try {
        return parseInt(atob(encoded)) - 256
    } catch (e) {
        return null;
    }
}